import { Grid } from "@mui/system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MainCard from "../../components/MainCard";
import DynamicForm from "../../components/Forms/DynamicForm";
import { createBlogFormConfig } from "../../utils/AdminFeatures/formConfig";
import { createBlog } from "../../services/blogsService";
import { Alert, Snackbar } from "@mui/material";

export default function BlogCreate() {
  const navigate = useNavigate();

  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const handleSubmit = async (formValues) => {
    try {
      console.log("Submitting blog data:", formValues);

      const response = await createBlog(formValues);

      setNotification({
        open: true,
        message: "Blog created successfully!",
        severity: "success"
      });

      // Optional navigation
      // setTimeout(() => navigate("/blog-list"), 1500);

    } catch (error) {
      setNotification({
        open: true,
        message: error?.response?.data?.message || "Failed to create blog",
        severity: "error"
      });
    }
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  return (
    <MainCard>
      <Grid size={{ xs: 12, md: 7, lg: 8 }}>
        <MainCard sx={{ mt: 2 }} content={false}>
          <DynamicForm
            config={createBlogFormConfig}
            onSubmit={handleSubmit}
          />
        </MainCard>
      </Grid>

      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </MainCard>
  );
}